import type { ReactNode } from 'react';

interface RouteProps {
  path?: string;
  element?: ReactNode;
}

export const BrowserRouter = ({ children }: { children: ReactNode }) => <>{children}</>;
export const Routes = ({ children }: { children: ReactNode }) => <>{children}</>;
export const Route = ({ element }: RouteProps) => <>{element}</>;
export const Link = ({
  children,
  to,
  className,
  ...rest
}: {
  children: ReactNode;
  to: string;
  className?: string;
  [key: string]: unknown;
}) => (
  <a href={String(to)} className={className} {...rest}>
    {children}
  </a>
);
export const useNavigate = () => jest.fn();
export const useLocation = () => ({ pathname: '/', search: '', hash: '', state: null });
export const useParams = () => ({});
